module.exports = __webpack_public_path__ + "img/img1.2e24d52f.png";